import { BisLookup, BisDetails } from '../domain/bislookupitem';

// PRH Opendata Registered Notices API v3
// Schema: https://avoindata.prh.fi/opendata-registerednotices-api/v3/schema?lang=fi
// Swagger: https://avoindata.prh.fi/fi/krek/swagger-ui
const baseUrl = 'https://avoindata.prh.fi/opendata-registerednotices-api/v3/';

export const PAGE_SIZE = 50;

export function SearchByTerm(term, page) {
    let url = `${baseUrl}?name=${encodeURIComponent(term)}`;
    if (page != null && page > 1) {
        url += `&page=${page}`;
    }
    let promise = new Promise((resolve, reject) => {
        fetch(url)
            .then((resp) => resp.json())
            .then((data) => {
                resolve(new BisLookup(data));
            })
            .catch(function (e) {
                console.log('error: ' + e);
                reject();
            });
    });
    return promise;
}

export function SearchByBusinessId(id) {
    let promise = new Promise((resolve, reject) => {
        fetch(`${baseUrl}${id}`)
            .then((resp) => resp.json())
            .then((data) => {
                resolve(data != null ? new BisDetails(data) : null);
            })
            .catch(function (e) {
                console.log('error: ' + e);
                reject();
            });
    });
    return promise;
}

